import React from "react";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import CloseOutlined from "@mui/icons-material/CloseOutlined";
import ArchiveOutlined from "@mui/icons-material/ArchiveOutlined";
import DeleteOutline from "@mui/icons-material/DeleteOutline";
import MarkEmailReadOutlined from "@mui/icons-material/MarkEmailReadOutlined";
import MarkEmailUnreadOutlined from "@mui/icons-material/MarkEmailUnreadOutlined";
import UnarchiveOutlined from "@mui/icons-material/UnarchiveOutlined";

function TooltipIconButton({ title, children }) {
  return (
    <Tooltip title={title} placement="top" arrow>
      <Box component="span" sx={{ display: "inline-flex", verticalAlign: "middle" }}>
        {children}
      </Box>
    </Tooltip>
  );
}

const DialogNotifica = ({
  open,
  onClose,
  notification,
  variant,
  onToggleRead,
  onArchive,
  onDelete,
  onRestore,
  readOnly = false,
}) => {
  if (!notification) return null;

  const isArchived = variant === "archived";
  const unread = !notification.isRead && !isArchived;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "16px",
          overflow: "hidden",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: 2,
          pb: 1,
          pt: 2.5,
          px: 2.5,
          borderBottom: "1px solid #eee",
        }}
      >
        <Box minWidth={0}>
          <Typography
            sx={{
              fontFamily: "Rubik",
              fontSize: 12,
              color: "#808080",
              mb: 0.5,
            }}
          >
            {notification.date}
          </Typography>
          <Typography
            sx={{
              fontFamily: "Rubik",
              fontWeight: unread ? "bold" : 600,
              color: "#0b3d87",
              fontSize: 20,
              lineHeight: 1.3,
              pr: 1,
              wordBreak: "break-word",
            }}
          >
            {notification.title}
          </Typography>
        </Box>
        <TooltipIconButton title="Chiudi">
          <IconButton aria-label="Chiudi" onClick={onClose} size="small" sx={{ mt: -0.5 }}>
            <CloseOutlined sx={{ color: "#0b3d87" }} />
          </IconButton>
        </TooltipIconButton>
      </DialogTitle>

      <DialogContent sx={{ px: 2.5, pb: 2, pt: 2 }}>
        <Typography
          sx={{
            fontFamily: "Rubik",
            color: "#333",
            fontSize: 15,
            lineHeight: 1.6,
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
          }}
        >
          {notification.description}
        </Typography>

        <Box
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
          gap={1}
          flexWrap="wrap"
          mt={3}
          pt={2}
          borderTop="1px solid #eee"
        >
          {isArchived ? (
            <>
              <TooltipIconButton title="Ripristina la notifica nell'elenco principale">
                <IconButton
                  aria-label="Ripristina notifica"
                  disabled={readOnly}
                  onClick={() => {
                    onRestore(notification.id);
                    onClose();
                  }}
                >
                  <UnarchiveOutlined sx={{ color: "#0b3d87", fontSize: 28 }} />
                </IconButton>
              </TooltipIconButton>
              <TooltipIconButton title="Elimina definitivamente la notifica">
                <IconButton
                  aria-label="Elimina notifica"
                  disabled={readOnly}
                  onClick={() => {
                    onDelete(notification.id);
                    onClose();
                  }}
                >
                  <DeleteOutline sx={{ color: "#e00036", fontSize: 28 }} />
                </IconButton>
              </TooltipIconButton>
            </>
          ) : (
            <>
              <TooltipIconButton
                title={notification.isRead ? "Segna come non letta" : "Segna come letta"}
              >
                <IconButton
                  aria-label={notification.isRead ? "Segna come non letta" : "Segna come letta"}
                  disabled={readOnly}
                  onClick={() => onToggleRead(notification.id)}
                >
                  {notification.isRead ? (
                    <MarkEmailUnreadOutlined sx={{ color: "#0b3d87", fontSize: 28 }} />
                  ) : (
                    <MarkEmailReadOutlined sx={{ color: "#0b3d87", fontSize: 28 }} />
                  )}
                </IconButton>
              </TooltipIconButton>
              <TooltipIconButton title="Archivia la notifica">
                <IconButton
                  aria-label="Archivia notifica"
                  disabled={readOnly}
                  onClick={() => {
                    onArchive(notification.id);
                    onClose();
                  }}
                >
                  <ArchiveOutlined sx={{ color: "#ed6c02", fontSize: 28 }} />
                </IconButton>
              </TooltipIconButton>
              <TooltipIconButton title="Elimina definitivamente la notifica">
                <IconButton
                  aria-label="Elimina notifica"
                  disabled={readOnly}
                  onClick={() => {
                    onDelete(notification.id);
                    onClose();
                  }}
                >
                  <DeleteOutline sx={{ color: "#e00036", fontSize: 28 }} />
                </IconButton>
              </TooltipIconButton>
            </>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default DialogNotifica;
